export default {
    TOGGLE_AFSP_LOGIN_MODAL: 'TOGGLE_AFSP_LOGIN_MODAL',
    TOGGLE_AFSP_LOGIN_STATUS_MODAL: 'TOGGLE_AFSP_LOGIN_STATUS_MODAL',
    TOGGLE_AFSP_PASSWORD_RESET_MODAL: 'TOGGLE_AFSP_PASSWORD_RESET_MODAL',
    TOGGLE_AFSP_LOGIN_BUTTON_DISABLE: 'TOGGLE_AFSP_LOGIN_BUTTON_DISABLE',
    CHANGE_AFSP_LOGIN_MODAL_VIEW: 'CHANGE_AFSP_LOGIN_MODAL_VIEW',
    DO_AFSP_LOG_IN: 'DO_AFSP_LOG_IN',
    AFSP_LOGIN_REQUEST_PENDING: 'AFSP_LOGIN_REQUEST_PENDING',
    AFSP_LOGIN_REQUEST_SUCCESS: 'AFSP_LOGIN_REQUEST_SUCCESS',
    AFSP_LOGIN_REQUEST_FAILURE: 'AFSP_LOGIN_REQUEST_FAILURE',
    AFSP_PASSWORD_RESET_REQUEST_PENDING: 'AFSP_PASSWORD_RESET_REQUEST_PENDING',
    AFSP_PASSWORD_RESET_REQUEST_SUCCESS: 'AFSP_PASSWORD_RESET_REQUEST_SUCCESS',
    AFSP_PASSWORD_RESET_REQUEST_FAILURE: 'AFSP_PASSWORD_RESET_REQUEST_FAILURE',
    REACTIVATE_USER_PENDING: 'REACTIVATE_USER_PENDING',
    REACTIVATE_USER_SUCCESS: 'REACTIVATE_USER_SUCCESS',
    REACTIVATE_USER_FAILURE: 'REACTIVATE_USER_FAILURE',
    RESET_AFSP_PASSWORD_RESET_REQUEST: 'RESET_AFSP_PASSWORD_RESET_REQUEST',
    RESET_AFSP_LOGIN_REQUEST: 'RESET_AFSP_LOGIN_REQUEST'
}